var scope_0 = require('/builds/Leonti/avobot-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2877d54945d04c95183613a7d32ffb08.js').default;
var scope_1 = require('/builds/Leonti/avobot-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42b1743c03de59fec6149605aa890c69.js').default;
var scope_2 = require('/builds/Leonti/avobot-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4873213051942ca9b61d6df877772862.js').default;
var scope_3 = require('/builds/Leonti/avobot-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/86436d8fc263fd92020b9a4367126097.js').default;
var scope_4 = require('/builds/Leonti/avobot-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0312ef2fc6ea9097cf86127390a778e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    